import { Badge } from '@synqo/frontend-component-library';
import type { MouseEvent } from 'react';

interface IProps {
    label: string;
    /** Opens the booking on the other side of the cancellation. */
    onOpen: () => void;
}

const keepRowSelection = (event: MouseEvent) => event.stopPropagation();

/** The badge of a cancelled booking or a counter booking in the journal, which opens the other booking. */
// @ai-generated 2026-10-26T15:30:00+00:00 by matthias.gessinger@synqony.com using Claude Sonnet 5.5
export function BookingStateBadge({ label, onOpen }: IProps) {
    return (
        <div onClick={keepRowSelection}>
            <Badge size="xs" onClick={onOpen}>
                {label}
            </Badge>
        </div>
    );
}
